import script from "./checkoutMove.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkoutMove.vue?vue&type=script&lang=ts&setup=true"

import "./checkoutMove.vue?vue&type=style&index=0&id=bb8bc3d2&scoped=true&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8bc3d2"]])

export default __exports__